import { getDomainConfigValue } from "./domain-config";

export function getQuizLink() {
  return window.domainConfig.linkToQuiz
    ? window.domainConfig.linkToQuiz
    : "https://quiz.xr-academy.com";
}

export function getPlayNowLink() {
  return window.domainConfig.playNowLink || "";
}

export function getPlayAndWinLink() {
  return (
    window.domainConfig.linkToPlayAndWin || "https://quiz.xr-academy.com"
  );
}

export function getWorldCupQuizLink() {
  const src = getDomainConfigValue("linkToWorldCupQuiz");
  return src ? src : "https://quiz.xr-academy.com";
}

export function hasPlayAndWinLink() {
  return !!getDomainConfigValue("linkToPlayAndWin");
}

export function hasPlayNowLink() {
  return !!getDomainConfigValue("playNowLink");
}

export function hasWorldCupQuizLink() {
  return !!getDomainConfigValue("linkToWorldCupQuiz");
}
